import type { EnrollmentInfoCertificatesItem } from './enrollmentInfoCertificatesItem';
import type { EnrollmentInfoEnrollmentType } from './enrollmentInfoEnrollmentType';
import type { EnrollmentInfoProgress } from './enrollmentInfoProgress';
import type { EnrollmentInfoStatus } from './enrollmentInfoStatus';

export interface EnrollmentInfo {
  /**
   * 취소 사유
   * @nullable
   */
  cancellationReason?: string | null;
  /**
   * 수강 취소 일시
   * @nullable
   */
  cancelledAt?: string | null;
  /** 수료증 목록 */
  certificates?: EnrollmentInfoCertificatesItem[];
  /**
   * 수강 완료 일시
   * @nullable
   */
  completedAt?: string | null;
  /** 강좌 ID */
  courseId: string;
  /** 수강신청 일시 */
  enrolledAt: string;
  /** 수강신청 고유 ID */
  enrollmentId: string;
  /** 수강신청 번호 */
  enrollmentNumber: string;
  /** 수강신청 유형 */
  enrollmentType: EnrollmentInfoEnrollmentType;
  /** 수료증 보유 여부 */
  hasCertificate?: boolean;
  progress: EnrollmentInfoProgress;
  /** 수강신청 상태 */
  status: EnrollmentInfoStatus;
  /** 학생 ID */
  studentId: string;
  /**
   * 수강 유효 기간
   * @nullable
   */
  validUntil?: string | null;
}
